import React, { useRef } from "react";
import { useGLTF, PerspectiveCamera } from "@react-three/drei";

export function Model(props) {
  const { nodes, materials } = useGLTF("/sc_turismo_scene.glb");
  return (
    <group {...props} dispose={null}>
      <PerspectiveCamera
        makeDefault={true}
        far={1000}
        near={0.1}
        fov={22.89519205}
        position={[2.45473552, 2.59906673, -4.10911512]}
        rotation={[-2.57760947, 0.46753715, 2.86389203]}
      />
      <mesh
        geometry={nodes.T2_B001.geometry}
        material={materials.T2_B}
        position={[0, 0, -0.3700254]}
        rotation={[Math.PI / 2, -1.6e-7, Math.PI]}
        scale={0.99406052}
      />
      <mesh
        geometry={nodes.Sphere002.geometry}
        material={materials.T10}
        position={[1.7239393, 0.82668751, 4.69620085]}
        rotation={[Math.PI, -3.3e-7, Math.PI]}
        scale={0.74040246}
      />
      <mesh
        geometry={nodes.T7001.geometry}
        material={materials.T10}
        position={[-0.47377744, -0.13412064, -0.15062362]}
        rotation={[0, 0, -0.33859899]}
        scale={[0.02305856, 0.02255301, 0.02305856]}
      />
      <mesh
        geometry={nodes.T2001.geometry}
        material={materials.T10}
        position={[0, 0, 0.37860212]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={0.12734424}
      />
      <mesh
        geometry={nodes.T5001.geometry}
        material={materials.T5}
        position={[0, 0, -0.3528311]}
        rotation={[Math.PI / 2, -1.6e-7, Math.PI]}
      />
      <mesh
        geometry={nodes.tree001.geometry}
        material={materials.T10}
        position={[-1.87227297, 1.03762662, 4.09884405]}
        scale={0.77475619}
      />
      <mesh geometry={nodes.T10001.geometry} material={materials.T10} />
      <mesh
        geometry={nodes.T6001.geometry}
        material={materials.T10}
        position={[-0.59070086, 0.00119568, -0.12974916]}
        rotation={[3.13952535, 0.01957848, -2.90635738]}
        scale={[0.71660072, 0.71660054, 0.7166006]}
      />
      <mesh
        geometry={nodes.T3001.geometry}
        material={materials.T10}
        position={[0, 0, -0.3528311]}
        rotation={[Math.PI / 2, -1.6e-7, Math.PI]}
      />
      <mesh
        geometry={nodes.T9001.geometry}
        material={materials.T9}
        position={[0, 0, -0.34141368]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.09464735, 0.00220702, 0.09464735]}
      />
      <mesh
        geometry={nodes.T8001.geometry}
        material={materials.T10}
        position={[0, 0, -0.34644806]}
        rotation={[Math.PI / 2, -1.6e-7, Math.PI]}
      />
      <mesh
        geometry={nodes.logo_separated001.geometry}
        material={materials["Logo Bake"]}
        position={[0.34467676, 1.67415667, 3.85406637]}
        rotation={[Math.PI / 2, -1.6e-7, Math.PI]}
        scale={0.51759481}
      />
      <mesh
        geometry={nodes.T4001.geometry}
        material={materials.T4}
        position={[0, 0, 0.00130921]}
        rotation={[Math.PI / 2, -4.9e-7, Math.PI]}
      />
      <mesh
        geometry={nodes.pillar1.geometry}
        material={materials.B1}
        position={[2.12052727, -0.24225353, 2.87942624]}
        scale={0.83379239}
      />
      <mesh
        geometry={nodes.pillar2.geometry}
        material={materials.B2}
        position={[0.03291823, -0.24225353, 2.87942624]}
        scale={0.83379239}
      />
      <mesh
        geometry={nodes.rock003.geometry}
        material={materials["Material.001"]}
        position={[-0.23528527, -1.0027734, 9.36371136]}
        rotation={[-2.06994883, 0.3258992, 1.65650226]}
        scale={[3.72814298, 3.4940958, 4.48055267]}
      />
      <mesh
        geometry={nodes.plant001.geometry}
        material={materials.B4}
        position={[2.47712493, -0.61694378, 3.5254488]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[0.50723642, 0.50723648, 0.50723648]}
      />
      <mesh
        geometry={nodes.stand001.geometry}
        material={materials["B-stand-small"]}
        position={[0, -1.22378254, 0]}
      />
      <mesh
        geometry={nodes.rock002.geometry}
        material={materials["B-rock1"]}
        position={[1.91461062, -0.3055782, 3.26482606]}
        rotation={[Math.PI, -1.4e-7, 1.40379978]}
      />
      <mesh
        geometry={nodes.T1001.geometry}
        material={materials.T1}
        rotation={[Math.PI / 2, -4.9e-7, Math.PI]}
      />
    </group>
  );
}

useGLTF.preload("/sc_turismo_scene.glb");